<i18n lang="yaml">
en:
  panel: 'Control Panel'
  speed: 'Network Speed Test'
ru:
  panel: 'Панель управления'
  speed: 'Проверка скорости сети'
</i18n>

<template>
  <div class="footer__corporate-links">
    <a
      class="footer__corporate-link"
      href="tel:+78005550675"
      data-gtmid="gtm-selectel-call-click"
    >
      +7&nbsp;(800)&nbsp;555-06-75
    </a>
    <a
      class="footer__corporate-link"
      href="https://my.selectel.ru"
      rel="noopener noreferrer"
      target="_blank"
    >
      <img
        class="footer__logo"
        :src="require('~/assets/icons/footer/panel.svg?inline').default"
        alt=""
      >
      {{ $t('panel') }}
    </a>
    <a
      class="footer__corporate-link"
      href="mailto:sales@selectel.ru"
      data-gtmid="gtm-selectel-mailto-click"
    >
      <img
        class="footer__logo"
        :src="require('~/assets/icons/footer/mail.svg?inline').default"
        alt=""
      >
      sales@selectel.ru
    </a>
    <a
      class="footer__corporate-link footer__corporate-link-status"
      :class="`footer__corporate-link-status--${statusPanel}`"
      href="http://status.selectel.info/"
      rel="noopener noreferrer"
      target="_blank"
    >
      {{ statusPanelMessage[$i18n.locale] }}
    </a>
    <a
      class="footer__corporate-link"
      href="https://speedtest.selectel.ru/"
      rel="noopener noreferrer"
      target="_blank"
    >
      <img
        class="footer__logo"
        :src="require('~/assets/icons/footer/speedtest.svg?inline').default"
        alt=""
      >
      {{ $t('speed') }}
    </a>
    <nuxt-link
      :to="switchLocalePath($i18n.locale === 'ru' ? 'en' : 'ru')"
      class="footer__corporate-link"
    >
      <img
        class="footer__logo"
        :src="require('~/assets/icons/footer/lang.svg?inline').default"
        alt=""
      >
      {{ $i18n.locale === 'ru' ? 'English' : 'Русский' }}
    </nuxt-link>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  name: 'FooterContacts',
  computed: {
    ...mapGetters('modules/status-panel', ['statusPanelMessage', 'statusPanel'])
  }
}
</script>

<style lang="scss">
.footer__corporate-links {
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  @media (max-width: $breakpoint-md) {
    margin: 28px 10px 0;
  }
}

.footer__corporate-link {
  display: inline-flex;
  align-items: center;
  margin: 0 -4px 8px;
  padding: 0 4px;
  font-size: 14px;

  color: #FFF;
  border-radius: 2px;
  transition: background-color 0.2s;

  &:hover {
    color: #FFF;
    background-color: rgba(#FFF, 0.15);
  }
}

.footer__corporate-link-status {
  padding-left: 28px;
  max-width: 95%;

  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  background-image: url('~@/assets/icons/single/status-panel/success.svg?inline');
  background-size: 8px 8px;
  background-repeat: no-repeat;
  background-position: left 8px center;

  @media (max-width: $breakpoint-md) {
    max-width: 100%;
  }
}

.footer__corporate-link-status--warn {
  background-image: url('~@/assets/icons/single/status-panel/warn.svg?inline');
}

.footer__corporate-link-status--error {
  background-image: url('~@/assets/icons/single/status-panel/error.svg?inline');
}

.footer__corporate-link-status--alert {
  background-image: url('~@/assets/icons/single/status-panel/alert.svg?inline');
}
</style>